// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1754) return "static/chunks/1754-c20f8c7a474a4443.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3415 ? "620394ce" : chunkId) + "." + {"3415":"57e8570cd4f17bf6","5502":"8f4bd4741ac54919","8318":"729ee109b710dc10"}[chunkId] + ".js";
};